import { render, staticRenderFns } from "./DiagnosisCatalog.vue?vue&type=template&id=524e52e0&scoped=true&lang=pug"
import script from "./DiagnosisCatalog.vue?vue&type=script&lang=js"
export * from "./DiagnosisCatalog.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisCatalog.vue?vue&type=style&index=0&id=524e52e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e52e0",
  null
  
)

export default component.exports